import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const hadeesCollections = [
  {
    subtitle: "SAHIH_BUKHARI",
    displayName: "Sahih al-Bukhari",
    volumes: [
      { name: "Volume 1", file: "images/Hadees/SAHIH_BUKHARI/SB_001.pdf" },
      { name: "Volume 2", file: "images/Hadees/SAHIH_BUKHARI/SB_002.pdf" },
      { name: "Volume 3", file: "images/Hadees/SAHIH_BUKHARI/SB_003.pdf" },
      { name: "Volume 4", file: "images/Hadees/SAHIH_BUKHARI/SB_004.pdf" },
      { name: "Volume 5", file: "images/Hadees/SAHIH_BUKHARI/SB_005.pdf" },
      { name: "Volume 6", file: "images/Hadees/SAHIH_BUKHARI/SB_006.pdf" },
    ],
  },
  {
    subtitle: "SAHIH_MUSLIM",
    displayName: "Sahih Muslim",
    volumes: [
      { name: "Volume 1", file: "images/Hadees/SAHIH_MUSLIM/SM_01.pdf" },
      { name: "Volume 2", file: "images/Hadees/SAHIH_MUSLIM/SM_02.pdf" },
      { name: "Volume 3", file: "images/Hadees/SAHIH_MUSLIM/SM_03.pdf" },
      { name: "Volume 4", file: "images/Hadees/SAHIH_MUSLIM/SM_04.pdf" },
      { name: "Volume 5", file: "images/Hadees/SAHIH_MUSLIM/SM_05.pdf" },
    ],
  },
  {
    subtitle: "JAMI_AT_TIRMIDHI",
    displayName: "Jami' at-Tirmidhi",
    volumes: [
      { name: "Volume 1", file: "images/Hadees/JAMI_AT_TIRMIDHI/JT_01.pdf" },
      { name: "Volume 2", file: "images/Hadees/JAMI_AT_TIRMIDHI/JT_02.pdf" },
    ],
  },
  {
    subtitle: "ABU_DAWOOD",
    displayName: "Sunan Abu Dawood",
    volumes: [
      { name: "Volume 1", file: "images/Hadees/ABU_DAWOOD/AB_01.pdf" },
      { name: "Volume 2", file: "images/Hadees/ABU_DAWOOD/AB_02.pdf" },
      { name: "Volume 3", file: "images/Hadees/ABU_DAWOOD/AB_03.pdf" },
      { name: "Volume 4", file: "images/Hadees/ABU_DAWOOD/AB_04.pdf" },
    ],
  },
  {
    subtitle: "IBN_MAJAH",
    displayName: "Sunan Ibn Majah",
    volumes: [
      { name: "Volume 1", file: "images/Hadees/IBN_MAJAH/IM_01.pdf" },
      { name: "Volume 2", file: "images/Hadees/IBN_MAJAH/IM_02.pdf" },
      { name: "Volume 3", file: "images/Hadees/IBN_MAJAH/IM_03.pdf" },
      { name: "Volume 4", file: "images/Hadees/IBN_MAJAH/IM_04.pdf" },
      { name: "Volume 5", file: "images/Hadees/IBN_MAJAH/IM_05.pdf" },
    ],
  },
  {
    subtitle: "SUNAN_NASAI",
    displayName: "Sunan an-Nasa'i",
    volumes: [
      { name: "Volume 1", file: "images/Hadees/SUNAN_NASAI/NS_01.pdf" },
      { name: "Volume 2", file: "images/Hadees/SUNAN_NASAI/NS_02.pdf" },
      { name: "Volume 3", file: "images/Hadees/SUNAN_NASAI/NS_03.pdf" },
      { name: "Volume 4", file: "images/Hadees/SUNAN_NASAI/NS_04.pdf" },
      { name: "Volume 5", file: "images/Hadees/SUNAN_NASAI/NS_05.pdf" },
      { name: "Volume 6", file: "images/Hadees/SUNAN_NASAI/NS_06.pdf" },
      { name: "Volume 7", file: "images/Hadees/SUNAN_NASAI/NS_07.pdf" },
    ],
  },
];

const otherPdfs = [
  { title: "Qur'an", subtitle: "Quran – Urdu Translation", link: "images/quran/Urdu.pdf", language: "Urdu" },
  { title: "Qur'an", subtitle: "Quran – Telugu Translation", link: "images/quran/Telugu.pdf", language: "Telugu" },
  { title: "Qur'an", subtitle: "Quran – English Translation", link: "images/quran/English.pdf", language: "English" },
  { title: "Aqeeda", subtitle: "Aqeedah Tawheed - Sh. Fawzan", link: "images/Aqeeda/aqeedah-tawheed-shakhfawzan-teluguislam.net-mobile-friendly.pdf", language: "Telugu" },
  { title: "Aqeeda", subtitle: "Four Principles of Shirk", link: "images/Aqeeda/four-principles-of-shirk-mobile-friendly.pdf", language: "Telugu" },
  { title: "Aqeeda", subtitle: "Taqwiyatul Iman", link: "images/Aqeeda/taqwiyatul-iman.pdf", language: "Telugu" },
  { title: "Aqeeda", subtitle: "Usool al-Thalatha", link: "images/Aqeeda/usool-al-thalatha-zulfi.pdf", language: "Telugu" },
  { title: "Aqeeda", subtitle: "Explanation of the Three Principles", link: "images/Aqeeda/Explanation of the Three Principles.pdf", language: "Urdu" },
  { title: "Seerat", subtitle: "Ar-Raheeq Al-Makhtum", link: "/images/Seerat/ar-raheeq-al-makhtoum-small-size.pdf", language: "Telugu" },
  { title: "Seerat", subtitle: "Ar-Raheeq Al-Makhtum", link: "/images/Seerat/Ar-raheeqAl-makhtumurdu.pdf", language: "Urdu" },
  { title: "Seerat", subtitle: "Mukhtasar Seerat", link: "/images/Seerat/Mukhtasar-Seerat.pdf", language: "Urdu" },
  { title: "Seerat", subtitle: "The Sealed Nectar", link: "/images/Seerat/sealed_nectar.pdf", language: "English" },
  { title: "Sunnah", subtitle: "Bidah - Sh. Fawzan", link: "/images/Sunnah/bida-sh.fawzan-book.pdf", language: "Telugu" },
  { title: "Sunnah", subtitle: "Following the Prophet's Sunnah", link: "/images/Sunnah/pravaktha-sunnath-anusarana-m.d-iqbal-kailani.pdf", language: "Telugu" },
  { title: "Sunnah", subtitle: "Obedience to the Prophet", link: "/images/Sunnah/pravaktha-vidheyatha-mobile.pdf", language: "Telugu" },
  { title: "Important Lessons", subtitle: "Important Lessons for Every Muslim", link: "images/Important lesson/urduimportantleassons.pdf", language: "Urdu" },
  { title: "Important Lessons", subtitle: "Important Lessons for Every Muslim", link: "images/Important lesson/telugu-importantleassons.pdf", language: "Telugu" },
];

const categoryConfig = {
  "Qur'an": { label: "Holy Qur'an" },
  "Aqeeda": { label: "Aqeeda" },
  "Seerat": { label: "Seerat" },
  "Sunnah": { label: "Sunnah" },
  "Important Lessons": { label: "Essential Lessons" },
};

const handleDownload = (filePath) => {
  const link = document.createElement('a');
  link.href = filePath;
  link.download = filePath.split('/').pop();
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const handleScrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

const PdfLibrary = () => {
  const [expandedHadees, setExpandedHadees] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("Qur'an");
  const [viewMode, setViewMode] = useState('grid');

  const handleToggle = (index) => {
    setExpandedHadees(expandedHadees === index ? null : index);
  };

  const otherGrouped = otherPdfs.reduce((acc, curr) => {
    acc[curr.title] = acc[curr.title] || [];
    acc[curr.title].push(curr);
    return acc;
  }, {});

  return (
    <div className="min-h-screen bg-white">

      {/* ── Hero Section ── */}
      <section className="relative h-screen min-h-[480px]">
        <div className="absolute inset-0">
          <img
            src="images/librarylanding.jpg"
            alt="Islamic Library"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/50"></div>
        </div>

        <div className="relative h-full flex items-center px-5 sm:px-8 md:px-14 lg:px-20 xl:px-32">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="max-w-4xl w-full"
          >
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: "3rem" }}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="h-1 bg-white mb-4 sm:mb-6 md:mb-8"
            ></motion.div>

            {/* Hero Heading — controlled at every breakpoint */}
            <h1 className="text-4xl xs:text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl font-black text-white mb-4 sm:mb-6 md:mb-8 leading-none">
              ISLAMIC
              <br />
              LIBRARY
            </h1>

            <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-white/90 mb-6 sm:mb-8 md:mb-12 font-light max-w-2xl leading-relaxed">
              Discover &amp; Download authentic Islamic knowledge through our comprehensive digital collection
            </p>

            <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 md:gap-6">
              <button
                onClick={() => handleScrollTo('hadees')}
                className="group relative overflow-hidden bg-white text-black px-5 sm:px-8 md:px-10 py-2.5 sm:py-3.5 md:py-5 text-xs sm:text-sm md:text-base lg:text-lg font-black text-center"
              >
                <span className="relative z-10 group-hover:opacity-0 transition-opacity duration-300">
                  EXPLORE HADEES
                </span>
                <span className="absolute inset-0 flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20 bg-gray-800 text-xs sm:text-sm md:text-base lg:text-lg font-black">
                  EXPLORE HADEES
                </span>
              </button>

              <button
                onClick={() => handleScrollTo('resources')}
                className="border-2 border-white text-white px-5 sm:px-8 md:px-10 py-2.5 sm:py-3.5 md:py-5 text-xs sm:text-sm md:text-base lg:text-lg font-black hover:bg-white hover:text-black transition-all duration-300 text-center"
              >
                VIEW RESOURCES
              </button>
            </div>
          </motion.div>
        </div>

        <div className="absolute bottom-6 sm:bottom-10 left-1/2 transform -translate-x-1/2 text-white">
          <motion.div animate={{ y: [0, 10, 0] }} transition={{ duration: 2, repeat: Infinity }}>
            <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
            </svg>
          </motion.div>
        </div>
      </section>

      {/* ── Islamic Resources Section ── */}
      <section id="resources" className="py-12 sm:py-16 md:py-20 lg:py-28 xl:py-32 px-5 sm:px-8 md:px-14 lg:px-20 xl:px-32 bg-gray-50">

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-8 sm:mb-12 md:mb-16 lg:mb-20"
        >
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5 sm:gap-6 md:gap-8 mb-6 sm:mb-8 md:mb-12">
            <div>
              {/* Section heading — never overflows */}
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-8xl font-black text-black leading-none mb-3 sm:mb-4 md:mb-6">
                ISLAMIC
                <br />
                RESOURCES
              </h2>
              <div className="w-12 sm:w-16 md:w-24 h-1 bg-gray-800"></div>
            </div>

            {/* View Toggle */}
            <div className="flex gap-2 sm:gap-3">
              <button
                onClick={() => setViewMode('grid')}
                className={`w-9 h-9 sm:w-11 sm:h-11 md:w-12 md:h-12 flex items-center justify-center ${viewMode === 'grid' ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'} transition-colors`}
              >
                <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                </svg>
              </button>
              <button
                onClick={() => setViewMode('list')}
                className={`w-9 h-9 sm:w-11 sm:h-11 md:w-12 md:h-12 flex items-center justify-center ${viewMode === 'list' ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'} transition-colors`}
              >
                <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
            </div>
          </div>
        </motion.div>

        {/* Category Pills */}
        <div className="flex flex-wrap gap-2 sm:gap-3 mb-8 sm:mb-10 md:mb-16">
          {Object.keys(otherGrouped).map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-3 sm:px-5 md:px-7 lg:px-8 py-1.5 sm:py-2.5 md:py-3 lg:py-4 text-xs sm:text-xs md:text-sm font-black tracking-wider transition-all ${
                selectedCategory === category
                  ? 'bg-gray-800 text-white'
                  : 'bg-white text-gray-800 hover:bg-gray-200'
              }`}
            >
              {categoryConfig[category].label.toUpperCase()}
            </button>
          ))}
        </div>

        {/* Grid / List Content */}
        <AnimatePresence mode="wait">
          <motion.div
            key={selectedCategory + viewMode}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
          >
            {viewMode === 'grid' ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-3 sm:gap-4 md:gap-5 lg:gap-6">
                {otherGrouped[selectedCategory].map((pdf, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: index * 0.05 }}
                    className="group bg-white hover:shadow-2xl transition-all duration-300"
                  >
                    <div className="aspect-[3/4] bg-gray-800 relative overflow-hidden">
                      <div className="absolute inset-0 flex items-center justify-center">
                        <svg className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 text-white/10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <div className="absolute top-2 right-2 bg-white text-gray-800 px-1.5 py-0.5 text-xs font-black">
                        {pdf.language}
                      </div>
                      <button
                        onClick={() => handleDownload(pdf.link)}
                        className="absolute inset-0 bg-black/0 hover:bg-black/80 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100 w-full"
                      >
                        <div className="text-white text-center">
                          <svg className="w-7 h-7 sm:w-9 sm:h-9 md:w-10 md:h-10 mx-auto mb-1 sm:mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                          </svg>
                          <div className="font-black text-xs">DOWNLOAD</div>
                        </div>
                      </button>
                    </div>
                    <div className="p-2 sm:p-3 md:p-4">
                      <h4 className="text-xs font-bold text-black mb-1 line-clamp-2 leading-snug">
                        {pdf.subtitle}
                      </h4>
                      <p className="text-xs text-gray-500 font-semibold">PDF Document</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            ) : (
              <div className="space-y-2">
                {otherGrouped[selectedCategory].map((pdf, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: index * 0.05 }}
                    className="group bg-white hover:bg-gray-100 transition-colors"
                  >
                    <div className="flex items-center gap-3 sm:gap-4 md:gap-6 p-3 sm:p-4 md:p-5 lg:p-6">
                      <div className="hidden sm:block text-xl md:text-2xl lg:text-3xl font-black text-gray-300 group-hover:text-gray-800 transition-colors w-8 md:w-12 lg:w-16 flex-shrink-0">
                        {String(index + 1).padStart(2, '0')}
                      </div>
                      <div className="w-9 h-12 sm:w-11 sm:h-15 md:w-14 md:h-18 lg:w-16 lg:h-20 bg-gray-800 flex-shrink-0 flex items-center justify-center">
                        <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 lg:w-8 lg:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <div className="flex-1 min-w-0">
                        <h4 className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl font-bold text-black mb-0.5 truncate">
                          {pdf.subtitle}
                        </h4>
                        <p className="text-xs text-gray-500 font-semibold">{pdf.language} Translation</p>
                      </div>
                      <button
                        onClick={() => handleDownload(pdf.link)}
                        className="flex-shrink-0 bg-gray-800 text-white px-2.5 sm:px-4 md:px-6 lg:px-8 py-1.5 sm:py-2.5 md:py-3 lg:py-4 font-black text-xs hover:bg-black transition-colors"
                      >
                        DOWNLOAD
                      </button>
                    </div>
                  </motion.div>
                ))}
              </div>
            )}
          </motion.div>
        </AnimatePresence>
      </section>

      {/* ── Hadees Collections Section ── */}
      <section id="hadees" className="py-12 sm:py-16 md:py-20 lg:py-28 xl:py-32 px-5 sm:px-8 md:px-14 lg:px-20 xl:px-32 bg-white">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-8 sm:mb-12 md:mb-16 lg:mb-20"
        >
          <div className="grid md:grid-cols-2 gap-6 sm:gap-8 md:gap-10 lg:gap-12 items-end mb-6 sm:mb-8 md:mb-12">
            <div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-8xl font-black text-black leading-none mb-3 sm:mb-4 md:mb-6">
                HADEES
                <br />
                COLLECTIONS
              </h2>
              <div className="w-12 sm:w-16 md:w-24 h-1 bg-gray-800"></div>
            </div>
            <div>
              <p className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl text-gray-600 leading-relaxed">
                The six most authentic Hadith collections (Kutub al-Sittah), meticulously preserved for scholars and students of Islamic knowledge.
              </p>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-2 sm:gap-4 md:gap-6 lg:gap-8 mb-8 sm:mb-10 md:mb-14 lg:mb-16">
            {[
              { num: hadeesCollections.length, label: "Collections" },
              { num: hadeesCollections.reduce((acc, col) => acc + col.volumes.length, 0), label: "Volumes" },
              { num: "100%", label: "Authentic" }
            ].map((stat, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1 }}
                viewport={{ once: true }}
                className="bg-gray-50 p-3 sm:p-5 md:p-6 lg:p-8"
              >
                <div className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-800 mb-1">
                  {stat.num}
                </div>
                <div className="text-xs sm:text-xs md:text-sm font-bold text-gray-600 tracking-widest">
                  {stat.label.toUpperCase()}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Accordion List */}
        <div className="space-y-2">
          {hadeesCollections.map((collection, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="border-b-2 border-gray-200 last:border-b-0"
            >
              <div
                className="group cursor-pointer py-4 sm:py-5 md:py-6 lg:py-8 flex items-center justify-between hover:bg-gray-50 transition-colors px-2 sm:px-3 md:px-4 lg:px-6"
                onClick={() => handleToggle(index)}
              >
                <div className="flex items-center gap-2 sm:gap-4 md:gap-6 lg:gap-8 flex-1 min-w-0">
                  {/* Index number */}
                  <div className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-black text-gray-300 group-hover:text-gray-800 transition-colors w-8 sm:w-10 md:w-14 lg:w-20 flex-shrink-0">
                    {String(index + 1).padStart(2, '0')}
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-base sm:text-lg md:text-2xl lg:text-3xl xl:text-4xl font-black text-black mb-0.5 sm:mb-1 md:mb-2 leading-tight">
                      {collection.displayName}
                    </h3>
                    <p className="text-xs sm:text-xs md:text-sm lg:text-base text-gray-600 font-semibold">
                      {collection.volumes.length} volumes available for download
                    </p>
                  </div>
                </div>
                <div className="text-gray-800 flex-shrink-0 ml-2">
                  <svg
                    className={`w-5 h-5 sm:w-6 sm:h-6 md:w-8 md:h-8 lg:w-10 lg:h-10 transition-transform duration-300 ${expandedHadees === index ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>

              <AnimatePresence>
                {expandedHadees === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.4 }}
                    className="overflow-hidden"
                  >
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2 sm:gap-3 md:gap-4 px-2 sm:px-3 md:px-4 lg:px-6 pb-4 sm:pb-6 md:pb-8">
                      {collection.volumes.map((vol, i) => (
                        <motion.button
                          key={i}
                          onClick={() => handleDownload(vol.file)}
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ delay: i * 0.05 }}
                          className="group/vol bg-gray-800 p-3 sm:p-4 md:p-5 lg:p-6 hover:bg-black transition-colors aspect-[3/4] flex flex-col justify-between w-full text-left"
                        >
                          <div className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-black text-white/20 group-hover/vol:text-white/40 transition-colors">
                            {String(i + 1).padStart(2, '0')}
                          </div>
                          <div>
                            <div className="text-white font-bold text-xs mb-1 sm:mb-2 md:mb-3 leading-tight">
                              {vol.name}
                            </div>
                            <div className="flex items-center gap-1 text-white text-xs">
                              <svg className="w-3 h-3 sm:w-3.5 sm:h-3.5 md:w-4 md:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                              </svg>
                              <span className="font-bold">PDF</span>
                            </div>
                          </div>
                        </motion.button>
                      ))}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </section>

    </div>
  );
};

export default PdfLibrary;

// working 26/03/24

// import React, { useState } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';

// const hadeesCollections = [
//   {
//     subtitle: "SAHIH_BUKHARI",
//     displayName: "Sahih al-Bukhari",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/SAHIH_BUKHARI/SB_001.pdf" },
//       { name: "Volume 2", file: "images/Hadees/SAHIH_BUKHARI/SB_002.pdf" },
//       { name: "Volume 3", file: "images/Hadees/SAHIH_BUKHARI/SB_003.pdf" },
//       { name: "Volume 4", file: "images/Hadees/SAHIH_BUKHARI/SB_004.pdf" },
//       { name: "Volume 5", file: "images/Hadees/SAHIH_BUKHARI/SB_005.pdf" },
//       { name: "Volume 6", file: "images/Hadees/SAHIH_BUKHARI/SB_006.pdf" },
//     ],
//   },
//   {
//     subtitle: "SAHIH_MUSLIM",
//     displayName: "Sahih Muslim",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/SAHIH_MUSLIM/SM_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/SAHIH_MUSLIM/SM_02.pdf" },
//       { name: "Volume 3", file: "images/Hadees/SAHIH_MUSLIM/SM_03.pdf" },
//       { name: "Volume 4", file: "images/Hadees/SAHIH_MUSLIM/SM_04.pdf" },
//       { name: "Volume 5", file: "images/Hadees/SAHIH_MUSLIM/SM_05.pdf" },
//     ],
//   },
//     {
//     subtitle: "JAMI_AT_TIRMIDHI",
//     displayName: "Jami' at-Tirmidhi",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/JAMI_AT_TIRMIDHI/JT_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/JAMI_AT_TIRMIDHI/JT_02.pdf" },
//     ],
//   },
//   {
//     subtitle: "ABU_DAWOOD",
//     displayName: "Sunan Abu Dawood",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/ABU_DAWOOD/AB_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/ABU_DAWOOD/AB_02.pdf" },
//       { name: "Volume 3", file: "images/Hadees/ABU_DAWOOD/AB_03.pdf" },
//       { name: "Volume 4", file: "images/Hadees/ABU_DAWOOD/AB_04.pdf" },
//     ],
//   },
//   {
//     subtitle: "IBN_MAJAH",
//     displayName: "Sunan Ibn Majah",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/IBN_MAJAH/IM_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/IBN_MAJAH/IM_02.pdf" },
//       { name: "Volume 3", file: "images/Hadees/IBN_MAJAH/IM_03.pdf" },
//       { name: "Volume 4", file: "images/Hadees/IBN_MAJAH/IM_04.pdf" },
//       { name: "Volume 5", file: "images/Hadees/IBN_MAJAH/IM_05.pdf" },
//     ],
//   },

  
//   {
//     subtitle: "SUNAN_NASAI",
//     displayName: "Sunan an-Nasa'i",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/SUNAN_NASAI/NS_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/SUNAN_NASAI/NS_02.pdf" },
//       { name: "Volume 3", file: "images/Hadees/SUNAN_NASAI/NS_03.pdf" },
//       { name: "Volume 4", file: "images/Hadees/SUNAN_NASAI/NS_04.pdf" },
//       { name: "Volume 5", file: "images/Hadees/SUNAN_NASAI/NS_05.pdf" },
//       { name: "Volume 6", file: "images/Hadees/SUNAN_NASAI/NS_06.pdf" },
//       { name: "Volume 7", file: "images/Hadees/SUNAN_NASAI/NS_07.pdf" },
//     ],
//   },
// ];

// const otherPdfs = [
//   { title: "Qur'an", subtitle: "Quran – Urdu Translation", link: "images/quran/Urdu.pdf", language: "Urdu" },
//   { title: "Qur'an", subtitle: "Quran – Telugu Translation", link: "images/quran/Telugu.pdf", language: "Telugu" },
//   { title: "Qur'an", subtitle: "Quran – English Translation", link: "images/quran/English.pdf", language: "English" },
//   { title: "Aqeeda", subtitle: "Aqeedah Tawheed - Sh. Fawzan", link: "images/Aqeeda/aqeedah-tawheed-shakhfawzan-teluguislam.net-mobile-friendly.pdf", language: "Telugu" },
//   { title: "Aqeeda", subtitle: "Four Principles of Shirk", link: "images/Aqeeda/four-principles-of-shirk-mobile-friendly.pdf", language: "Telugu" },
//   { title: "Aqeeda", subtitle: "Taqwiyatul Iman", link: "images/Aqeeda/taqwiyatul-iman.pdf", language: "Telugu" },
//   { title: "Aqeeda", subtitle: "Usool al-Thalatha", link: "images/Aqeeda/usool-al-thalatha-zulfi.pdf", language: "Telugu" },
//   { title: "Aqeeda", subtitle: "Explanation of the Three Principles", link: "images/Aqeeda/Explanation of the Three Principles.pdf", language: "Urdu" },
//   { title: "Seerat", subtitle: "Ar-Raheeq Al-Makhtum", link: "/images/Seerat/ar-raheeq-al-makhtoum-small-size.pdf", language: "Telugu" },
//   { title: "Seerat", subtitle: "Ar-Raheeq Al-Makhtum", link: "/images/Seerat/Ar-raheeqAl-makhtumurdu.pdf", language: "Urdu" },
//   { title: "Seerat", subtitle: "Mukhtasar Seerat", link: "/images/Seerat/Mukhtasar-Seerat.pdf", language: "Urdu" },
//   { title: "Seerat", subtitle: "The Sealed Nectar", link: "/images/Seerat/sealed_nectar.pdf", language: "English" },
//   { title: "Sunnah", subtitle: "Bidah - Sh. Fawzan", link: "/images/Sunnah/bida-sh.fawzan-book.pdf", language: "Telugu" },
//   { title: "Sunnah", subtitle: "Following the Prophet's Sunnah", link: "/images/Sunnah/pravaktha-sunnath-anusarana-m.d-iqbal-kailani.pdf", language: "Telugu" },
//   { title: "Sunnah", subtitle: "Obedience to the Prophet", link: "/images/Sunnah/pravaktha-vidheyatha-mobile.pdf", language: "Telugu" },
//   { title: "Important Lessons", subtitle: "Important Lessons for Every Muslim", link: "images/Important lesson/urduimportantleassons.pdf", language: "Urdu" },
//   { title: "Important Lessons", subtitle: "Important Lessons for Every Muslim", link: "images/Important lesson/telugu-importantleassons.pdf", language: "Telugu" },
// ];

// const categoryConfig = {
//   "Qur'an": { label: "Holy Qur'an", description: "Divine revelation in multiple languages" },
//   "Aqeeda": { label: "Aqeeda", description: "Foundations of Islamic faith" },
//   "Seerat": { label: "Seerat", description: "Life of Prophet Muhammad ﷺ" },
//   "Sunnah": { label: "Sunnah", description: "Prophetic traditions" },
//   "Important Lessons": { label: "Essential Lessons", description: "Core Islamic knowledge" },
// };

// const PdfLibrary = () => {
//   const [expandedHadees, setExpandedHadees] = useState(null);
//   const [selectedCategory, setSelectedCategory] = useState("Qur'an");
//   const [viewMode, setViewMode] = useState('grid');

//   const handleToggle = (index) => {
//     setExpandedHadees(expandedHadees === index ? null : index);
//   };

//   const otherGrouped = otherPdfs.reduce((acc, curr) => {
//     acc[curr.title] = acc[curr.title] || [];
//     acc[curr.title].push(curr);
//     return acc;
//   }, {});

//   return (
//     <div className="min-h-screen bg-white">
//       {/* Hero Section - Cinematic Full Width */}
//       <section className="relative h-screen">
//         <div className="absolute inset-0">
//           <img 
//             src="images/librarylanding.jpg"
//             alt="Islamic Library"
//             className="w-full h-full object-cover"
//           />
//           <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/50"></div>
//         </div>

//         <div className="relative h-full flex items-center px-8 md:px-20 lg:px-32">
//           <motion.div
//             initial={{ opacity: 0, y: 50 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 1 }}
//             className="max-w-4xl"
//           >
//             <motion.div
//               initial={{ width: 0 }}
//               animate={{ width: "4rem" }}
//               transition={{ duration: 0.8, delay: 0.3 }}
//               className="h-1 bg-white mb-8"
//             ></motion.div>

//             <h1 className="text-7xl md:text-9xl font-black text-white mb-8 leading-none">
//               ISLAMIC
//               <br />
//               LIBRARY
//             </h1>

//             <p className="text-2xl md:text-3xl text-white/90 mb-12 font-light max-w-2xl">
//               Discover & Download authentic Islamic knowledge through our comprehensive digital collection
//             </p>

//             <div className="flex flex-wrap gap-6">
//               <a
//                 href="#hadees"
//                 className="group relative overflow-hidden bg-white text-black px-10 py-5 text-lg font-black"
//               >
//                 <span className="relative z-10">EXPLORE HADEES</span>
//                 <div className="absolute inset-0 bg-gray-800 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-300"></div>
//                 <span className="absolute inset-0 flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20">
//                   EXPLORE HADEES
//                 </span>
//               </a>
//               <a
//                 href="#resources"
//                 className="border-2 border-white text-white px-10 py-5 text-lg font-black hover:bg-white hover:text-black transition-all duration-300"
//               >
//                 VIEW RESOURCES
//               </a>
//             </div>
//           </motion.div>
//         </div>

//         <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white">
//           <motion.div
//             animate={{ y: [0, 10, 0] }}
//             transition={{ duration: 2, repeat: Infinity }}
//           >
//             <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
//             </svg>
//           </motion.div>
//         </div>
//       </section>

    

//       {/* Other Resources - Dynamic Grid with Filter */}
//       <section id="resources" className="py-32 px-8 md:px-20 lg:px-32 bg-gray-50">
//         <motion.div
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           className="mb-20"
//         >
//           <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-12">
//             <div>
//               <h2 className="text-7xl md:text-8xl font-black text-black leading-none mb-6">
//                 ISLAMIC
//                 <br />
//                 RESOURCES
//               </h2>
//               <div className="w-24 h-1 bg-gray-800"></div>
//             </div>
            
//             <div className="flex gap-3">
//               <button
//                 onClick={() => setViewMode('grid')}
//                 className={`w-12 h-12 flex items-center justify-center ${viewMode === 'grid' ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'} transition-colors`}
//               >
//                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
//                 </svg>
//               </button>
//               <button
//                 onClick={() => setViewMode('list')}
//                 className={`w-12 h-12 flex items-center justify-center ${viewMode === 'list' ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'} transition-colors`}
//               >
//                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
//                 </svg>
//               </button>
//             </div>
//           </div>
//         </motion.div>

//         {/* Category Pills */}
//         <div className="flex flex-wrap gap-3 mb-16">
//           {Object.keys(otherGrouped).map((category) => (
//             <button
//               key={category}
//               onClick={() => setSelectedCategory(category)}
//               className={`px-8 py-4 text-sm font-black tracking-wider transition-all ${
//                 selectedCategory === category
//                   ? 'bg-gray-800 text-white'
//                   : 'bg-white text-gray-800 hover:bg-gray-200'
//               }`}
//             >
//               {categoryConfig[category].label.toUpperCase()}
//             </button>
//           ))}
//         </div>

//         {/* Content */}
//         <AnimatePresence mode="wait">
//           <motion.div
//             key={selectedCategory + viewMode}
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             exit={{ opacity: 0, y: -20 }}
//             transition={{ duration: 0.3 }}
//           >
//             {viewMode === 'grid' ? (
//               <div className="grid md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
//                 {otherGrouped[selectedCategory].map((pdf, index) => (
//                   <motion.div
//                     key={index}
//                     initial={{ opacity: 0, scale: 0.9 }}
//                     animate={{ opacity: 1, scale: 1 }}
//                     transition={{ delay: index * 0.05 }}
//                     className="group bg-white hover:shadow-2xl transition-all duration-300"
//                   >
//                     <div className="aspect-[3/4] bg-gray-800 relative overflow-hidden">
//                       <div className="absolute inset-0 flex items-center justify-center">
//                         <svg className="w-16 h-16 text-white/10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
//                         </svg>
//                       </div>
//                       <div className="absolute top-3 right-3 bg-white text-gray-800 px-2 py-1 text-xs font-black">
//                         {pdf.language}
//                       </div>
//                       <a
//                         href={pdf.link}
//                         download
//                         className="absolute inset-0 bg-black/0 hover:bg-black/80 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100"
//                       >
//                         <div className="text-white text-center">
//                           <svg className="w-10 h-10 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
//                           </svg>
//                           <div className="font-black text-sm">DOWNLOAD</div>
//                         </div>
//                       </a>
//                     </div>
//                     <div className="p-4">
//                       <h4 className="text-sm font-bold text-black mb-1 line-clamp-2">
//                         {pdf.subtitle}
//                       </h4>
//                       <p className="text-xs text-gray-600 font-semibold">PDF Document</p>
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>
//             ) : (
//               <div className="space-y-2">
//                 {otherGrouped[selectedCategory].map((pdf, index) => (
//                   <motion.div
//                     key={index}
//                     initial={{ opacity: 0, x: -20 }}
//                     animate={{ opacity: 1, x: 0 }}
//                     transition={{ delay: index * 0.05 }}
//                     className="group bg-white hover:bg-gray-100 transition-colors"
//                   >
//                     <div className="flex items-center gap-6 p-6">
//                       <div className="text-3xl font-black text-gray-300 group-hover:text-gray-800 transition-colors w-16">
//                         {String(index + 1).padStart(2, '0')}
//                       </div>
//                       <div className="w-16 h-20 bg-gray-800 flex-shrink-0 flex items-center justify-center">
//                         <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
//                         </svg>
//                       </div>
//                       <div className="flex-1 min-w-0">
//                         <h4 className="text-xl font-bold text-black mb-1 truncate">
//                           {pdf.subtitle}
//                         </h4>
//                         <p className="text-sm text-gray-600 font-semibold">{pdf.language} Translation</p>
//                       </div>
//                       <a
//                         href={pdf.link}
//                         download
//                         className="flex-shrink-0 bg-gray-800 text-white px-8 py-4 font-black text-sm hover:bg-black transition-colors"
//                       >
//                         DOWNLOAD
//                       </a>
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>
//             )}
//           </motion.div>
//         </AnimatePresence>
//       </section>
//   {/* Hadees Collections - Accordion with Preview Cards */}
//       <section id="hadees" className="py-32 px-8 md:px-20 lg:px-32 bg-white">
//         <motion.div
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           className="mb-20"
//         >
//           <div className="grid md:grid-cols-2 gap-12 items-end mb-12">
//             <div>
//               <h2 className="text-7xl md:text-8xl font-black text-black leading-none mb-6">
//                 HADEES
//                 <br />
//                 COLLECTIONS
//               </h2>
//               <div className="w-24 h-1 bg-gray-800"></div>
//             </div>
//             <div>
//               <p className="text-xl text-gray-600 leading-relaxed">
//                 The six most authentic Hadith collections (Kutub al-Sittah), meticulously preserved for scholars and students of Islamic knowledge.
//               </p>
//             </div>
//           </div>

//           <div className="grid md:grid-cols-3 gap-8 mb-16">
//             {[
//               { num: hadeesCollections.length, label: "Collections" },
//               { num: hadeesCollections.reduce((acc, col) => acc + col.volumes.length, 0), label: "Volumes" },
//               { num: "100%", label: "Authentic" }
//             ].map((stat, i) => (
//               <motion.div
//                 key={i}
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ delay: i * 0.1 }}
//                 viewport={{ once: true }}
//                 className="bg-gray-50 p-8"
//               >
//                 <div className="text-6xl font-black text-gray-800 mb-2">{stat.num}</div>
//                 <div className="text-sm font-bold text-gray-600 tracking-widest">{stat.label.toUpperCase()}</div>
//               </motion.div>
//             ))}
//           </div>
//         </motion.div>

//         <div className="space-y-2">
//           {hadeesCollections.map((collection, index) => (
//             <motion.div
//               key={index}
//               initial={{ opacity: 0, x: -30 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               transition={{ delay: index * 0.1 }}
//               viewport={{ once: true }}
//               className="border-b-2 border-gray-200 last:border-b-0"
//             >
//               <div
//                 className="group cursor-pointer py-8 flex items-center justify-between hover:bg-gray-50 transition-colors px-6"
//                 onClick={() => handleToggle(index)}
//               >
//                 <div className="flex items-center gap-8 flex-1">
//                   <div className="text-6xl font-black text-gray-300 group-hover:text-gray-800 transition-colors w-20">
//                     {String(index + 1).padStart(2, '0')}
//                   </div>
//                   <div>
//                     <h3 className="text-3xl md:text-4xl font-black text-black mb-2">
//                       {collection.displayName}
//                     </h3>
//                     <p className="text-gray-600 font-semibold">
//                       {collection.volumes.length} volumes available for download
//                     </p>
//                   </div>
//                 </div>
//                 <div className="text-gray-800">
//                   <svg 
//                     className={`w-10 h-10 transition-transform duration-300 ${expandedHadees === index ? 'rotate-180' : ''}`}
//                     fill="none" 
//                     stroke="currentColor" 
//                     viewBox="0 0 24 24"
//                   >
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 9l-7 7-7-7" />
//                   </svg>
//                 </div>
//               </div>

//               <AnimatePresence>
//                 {expandedHadees === index && (
//                   <motion.div
//                     initial={{ height: 0, opacity: 0 }}
//                     animate={{ height: "auto", opacity: 1 }}
//                     exit={{ height: 0, opacity: 0 }}
//                     transition={{ duration: 0.4 }}
//                     className="overflow-hidden"
//                   >
//                     <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 px-6 pb-8">
//                       {collection.volumes.map((vol, i) => (
//                         <motion.a
//                           key={i}
//                           href={vol.file}
//                           download
//                           initial={{ opacity: 0, y: 20 }}
//                           animate={{ opacity: 1, y: 0 }}
//                           transition={{ delay: i * 0.05 }}
//                           className="group/vol bg-gray-800 p-6 hover:bg-black transition-colors aspect-[3/4] flex flex-col justify-between"
//                         >
//                           <div className="text-4xl font-black text-white/20 group-hover/vol:text-white/40 transition-colors">
//                             {String(i + 1).padStart(2, '0')}
//                           </div>
//                           <div>
//                             <div className="text-white font-bold mb-3">{vol.name}</div>
//                             <div className="flex items-center gap-2 text-white text-sm">
//                               <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
//                               </svg>
//                               <span className="font-bold">PDF</span>
//                             </div>
//                           </div>
//                         </motion.a>
//                       ))}
//                     </div>
//                   </motion.div>
//                 )}
//               </AnimatePresence>
//             </motion.div>
//           ))}
//         </div>
//       </section>
//       {/* Footer */}
//       {/* <footer className="bg-gray-800 text-white py-20 px-8 md:px-20 lg:px-32">
//         <div className="max-w-6xl mx-auto text-center">
//           <h3 className="text-5xl md:text-6xl font-black mb-8">NEED ASSISTANCE?</h3>
//           <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto">
//             Our library team is available to help you find the resources you need
//           </p>
//           <button className="bg-white text-gray-800 px-12 py-5 text-lg font-black hover:bg-gray-200 transition-colors">
//             CONTACT SUPPORT
//           </button>
//         </div>
//       </footer> */}
//     </div>
//   );
// };

// export default PdfLibrary;


// import React, { useState } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';

// const hadeesCollections = [
//   {
//     subtitle: "ABU_DAWOOD",
//     displayName: "Sunan Abu Dawood",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/ABU_DAWOOD/AB_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/ABU_DAWOOD/AB_02.pdf" },
//       { name: "Volume 3", file: "images/Hadees/ABU_DAWOOD/AB_03.pdf" },
//       { name: "Volume 4", file: "images/Hadees/ABU_DAWOOD/AB_04.pdf" },
//     ],
//   },
//   {
//     subtitle: "IBN_MAJAH",
//     displayName: "Sunan Ibn Majah",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/IBN_MAJAH/IM_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/IBN_MAJAH/IM_02.pdf" },
//       { name: "Volume 3", file: "images/Hadees/IBN_MAJAH/IM_03.pdf" },
//       { name: "Volume 4", file: "images/Hadees/IBN_MAJAH/IM_04.pdf" },
//       { name: "Volume 5", file: "images/Hadees/IBN_MAJAH/IM_05.pdf" },
//     ],
//   },
//   {
//     subtitle: "JAMI_AT_TIRMIDHI",
//     displayName: "Jami' at-Tirmidhi",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/JAMI_AT_TIRMIDHI/JT_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/JAMI_AT_TIRMIDHI/JT_02.pdf" },
//     ],
//   },
//   {
//     subtitle: "SAHIH_BUKHARI",
//     displayName: "Sahih al-Bukhari",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/SAHIH_BUKHARI/SB_001.pdf" },
//       { name: "Volume 2", file: "images/Hadees/SAHIH_BUKHARI/SB_002.pdf" },
//       { name: "Volume 3", file: "images/Hadees/SAHIH_BUKHARI/SB_003.pdf" },
//       { name: "Volume 4", file: "images/Hadees/SAHIH_BUKHARI/SB_004.pdf" },
//       { name: "Volume 5", file: "images/Hadees/SAHIH_BUKHARI/SB_005.pdf" },
//       { name: "Volume 6", file: "images/Hadees/SAHIH_BUKHARI/SB_006.pdf" },
//     ],
//   },
//   {
//     subtitle: "SAHIH_MUSLIM",
//     displayName: "Sahih Muslim",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/SAHIH_MUSLIM/SM_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/SAHIH_MUSLIM/SM_02.pdf" },
//       { name: "Volume 3", file: "images/Hadees/SAHIH_MUSLIM/SM_03.pdf" },
//       { name: "Volume 4", file: "images/Hadees/SAHIH_MUSLIM/SM_04.pdf" },
//       { name: "Volume 5", file: "images/Hadees/SAHIH_MUSLIM/SM_05.pdf" },
//     ],
//   },
//   {
//     subtitle: "SUNAN_NASAI",
//     displayName: "Sunan an-Nasa'i",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/SUNAN_NASAI/NS_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/SUNAN_NASAI/NS_02.pdf" },
//       { name: "Volume 3", file: "images/Hadees/SUNAN_NASAI/NS_03.pdf" },
//       { name: "Volume 4", file: "images/Hadees/SUNAN_NASAI/NS_04.pdf" },
//       { name: "Volume 5", file: "images/Hadees/SUNAN_NASAI/NS_05.pdf" },
//       { name: "Volume 6", file: "images/Hadees/SUNAN_NASAI/NS_06.pdf" },
//       { name: "Volume 7", file: "images/Hadees/SUNAN_NASAI/NS_07.pdf" },
//     ],
//   },
// ];

// const otherPdfs = [
//   { title: "Qur'an", subtitle: "Quran – Urdu Translation", link: "images/quran/Urdu.pdf", language: "Urdu" },
//   { title: "Qur'an", subtitle: "Quran – Telugu Translation", link: "images/quran/Telugu.pdf", language: "Telugu" },
//   { title: "Qur'an", subtitle: "Quran – English Translation", link: "images/quran/English.pdf", language: "English" },
//   { title: "Aqeeda", subtitle: "Aqeedah Tawheed - Sh. Fawzan", link: "images/Aqeeda/aqeedah-tawheed-shakhfawzan-teluguislam.net-mobile-friendly.pdf", language: "Telugu" },
//   { title: "Aqeeda", subtitle: "Four Principles of Shirk", link: "images/Aqeeda/four-principles-of-shirk-mobile-friendly.pdf", language: "Telugu" },
//   { title: "Aqeeda", subtitle: "Taqwiyatul Iman", link: "images/Aqeeda/taqwiyatul-iman.pdf", language: "Telugu" },
//   { title: "Aqeeda", subtitle: "Usool al-Thalatha", link: "images/Aqeeda/usool-al-thalatha-zulfi.pdf", language: "Telugu" },
//   { title: "Aqeeda", subtitle: "Explanation of the Three Principles", link: "images/Aqeeda/Explanation of the Three Principles.pdf", language: "Urdu" },
//   { title: "Seerat", subtitle: "Ar-Raheeq Al-Makhtum", link: "/images/Seerat/ar-raheeq-al-makhtoum-small-size.pdf", language: "Telugu" },
//   { title: "Seerat", subtitle: "Ar-Raheeq Al-Makhtum", link: "/images/Seerat/Ar-raheeqAl-makhtumurdu.pdf", language: "Urdu" },
//   { title: "Seerat", subtitle: "Mukhtasar Seerat", link: "/images/Seerat/Mukhtasar-Seerat.pdf", language: "Urdu" },
//   { title: "Seerat", subtitle: "The Sealed Nectar", link: "/images/Seerat/sealed_nectar.pdf", language: "English" },
//   { title: "Sunnah", subtitle: "Bidah - Sh. Fawzan", link: "/images/Sunnah/bida-sh.fawzan-book.pdf", language: "Telugu" },
//   { title: "Sunnah", subtitle: "Following the Prophet's Sunnah", link: "/images/Sunnah/pravaktha-sunnath-anusarana-m.d-iqbal-kailani.pdf", language: "Telugu" },
//   { title: "Sunnah", subtitle: "Obedience to the Prophet", link: "/images/Sunnah/pravaktha-vidheyatha-mobile.pdf", language: "Telugu" },
//   { title: "Important Lessons", subtitle: "Important Lessons for Every Muslim", link: "images/Important lesson/urduimportantleassons.pdf", language: "Urdu" },
//   { title: "Important Lessons", subtitle: "Important Lessons for Every Muslim", link: "images/Important lesson/telugu-importantleassons.pdf", language: "Telugu" },
// ];

// const categoryConfig = {
//   "Qur'an": { label: "Holy Qur'an", description: "Divine revelation in multiple languages" },
//   "Aqeeda": { label: "Aqeeda", description: "Foundations of Islamic faith" },
//   "Seerat": { label: "Seerat", description: "Life of Prophet Muhammad ﷺ" },
//   "Sunnah": { label: "Sunnah", description: "Prophetic traditions" },
//   "Important Lessons": { label: "Essential Lessons", description: "Core Islamic knowledge" },
// };

// const PdfLibrary = () => {
//   const [expandedHadees, setExpandedHadees] = useState(null);
//   const [selectedCategory, setSelectedCategory] = useState("Qur'an");
//   const [viewMode, setViewMode] = useState('grid');

//   const handleToggle = (index) => {
//     setExpandedHadees(expandedHadees === index ? null : index);
//   };

//   const otherGrouped = otherPdfs.reduce((acc, curr) => {
//     acc[curr.title] = acc[curr.title] || [];
//     acc[curr.title].push(curr);
//     return acc;
//   }, {});

//   return (
//     <div className="min-h-screen bg-white">
//       {/* Hero Section - Cinematic Full Width */}
//       <section className="relative h-screen">
//         <div className="absolute inset-0">
//           <img 
//             src="https://images.unsplash.com/photo-1609599006353-e629aaabfeae?q=80&w=2831"
//             alt="Islamic Library"
//             className="w-full h-full object-cover"
//           />
//           <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/50"></div>
//         </div>

//         <div className="relative h-full flex items-center px-8 md:px-20 lg:px-32">
//           <motion.div
//             initial={{ opacity: 0, y: 50 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 1 }}
//             className="max-w-4xl"
//           >
//             <motion.div
//               initial={{ width: 0 }}
//               animate={{ width: "4rem" }}
//               transition={{ duration: 0.8, delay: 0.3 }}
//               className="h-1 bg-white mb-8"
//             ></motion.div>

//             <h1 className="text-7xl md:text-9xl font-black text-white mb-8 leading-none">
//               ISLAMIC
//               <br />
//               LIBRARY
//             </h1>

//             <p className="text-2xl md:text-3xl text-white/90 mb-12 font-light max-w-2xl">
//               Discover authentic Islamic knowledge through our comprehensive digital collection
//             </p>

//             <div className="flex flex-wrap gap-6">
//               <a
//                 href="#hadees"
//                 className="group relative overflow-hidden bg-white text-black px-10 py-5 text-lg font-black"
//               >
//                 <span className="relative z-10">EXPLORE HADEES</span>
//                 <div className="absolute inset-0 bg-gray-800 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-300"></div>
//                 <span className="absolute inset-0 flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20">
//                   EXPLORE HADEES
//                 </span>
//               </a>
//               <a
//                 href="#resources"
//                 className="border-2 border-white text-white px-10 py-5 text-lg font-black hover:bg-white hover:text-black transition-all duration-300"
//               >
//                 VIEW RESOURCES
//               </a>
//             </div>
//           </motion.div>
//         </div>

//         <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white">
//           <motion.div
//             animate={{ y: [0, 10, 0] }}
//             transition={{ duration: 2, repeat: Infinity }}
//           >
//             <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
//             </svg>
//           </motion.div>
//         </div>
//       </section>

//       {/* Hadees Collections - Accordion with Preview Cards */}
//       <section id="hadees" className="py-32 px-8 md:px-20 lg:px-32 bg-white">
//         <motion.div
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           className="mb-20"
//         >
//           <div className="grid md:grid-cols-2 gap-12 items-end mb-12">
//             <div>
//               <h2 className="text-7xl md:text-8xl font-black text-black leading-none mb-6">
//                 HADEES
//                 <br />
//                 COLLECTIONS
//               </h2>
//               <div className="w-24 h-1 bg-gray-800"></div>
//             </div>
//             <div>
//               <p className="text-xl text-gray-600 leading-relaxed">
//                 The six most authentic Hadith collections (Kutub al-Sittah), meticulously preserved for scholars and students of Islamic knowledge.
//               </p>
//             </div>
//           </div>

//           <div className="grid md:grid-cols-3 gap-8 mb-16">
//             {[
//               { num: hadeesCollections.length, label: "Collections" },
//               { num: hadeesCollections.reduce((acc, col) => acc + col.volumes.length, 0), label: "Volumes" },
//               { num: "100%", label: "Authentic" }
//             ].map((stat, i) => (
//               <motion.div
//                 key={i}
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ delay: i * 0.1 }}
//                 viewport={{ once: true }}
//                 className="bg-gray-50 p-8"
//               >
//                 <div className="text-6xl font-black text-gray-800 mb-2">{stat.num}</div>
//                 <div className="text-sm font-bold text-gray-600 tracking-widest">{stat.label.toUpperCase()}</div>
//               </motion.div>
//             ))}
//           </div>
//         </motion.div>

//         <div className="space-y-2">
//           {hadeesCollections.map((collection, index) => (
//             <motion.div
//               key={index}
//               initial={{ opacity: 0, x: -30 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               transition={{ delay: index * 0.1 }}
//               viewport={{ once: true }}
//               className="border-b-2 border-gray-200 last:border-b-0"
//             >
//               <div
//                 className="group cursor-pointer py-8 flex items-center justify-between hover:bg-gray-50 transition-colors px-6"
//                 onClick={() => handleToggle(index)}
//               >
//                 <div className="flex items-center gap-8 flex-1">
//                   <div className="text-6xl font-black text-gray-300 group-hover:text-gray-800 transition-colors w-20">
//                     {String(index + 1).padStart(2, '0')}
//                   </div>
//                   <div>
//                     <h3 className="text-3xl md:text-4xl font-black text-black mb-2">
//                       {collection.displayName}
//                     </h3>
//                     <p className="text-gray-600 font-semibold">
//                       {collection.volumes.length} volumes available for download
//                     </p>
//                   </div>
//                 </div>
//                 <div className="text-gray-800">
//                   <svg 
//                     className={`w-10 h-10 transition-transform duration-300 ${expandedHadees === index ? 'rotate-180' : ''}`}
//                     fill="none" 
//                     stroke="currentColor" 
//                     viewBox="0 0 24 24"
//                   >
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 9l-7 7-7-7" />
//                   </svg>
//                 </div>
//               </div>

//               <AnimatePresence>
//                 {expandedHadees === index && (
//                   <motion.div
//                     initial={{ height: 0, opacity: 0 }}
//                     animate={{ height: "auto", opacity: 1 }}
//                     exit={{ height: 0, opacity: 0 }}
//                     transition={{ duration: 0.4 }}
//                     className="overflow-hidden"
//                   >
//                     <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 px-6 pb-8">
//                       {collection.volumes.map((vol, i) => (
//                         <motion.a
//                           key={i}
//                           href={vol.file}
//                           download
//                           initial={{ opacity: 0, y: 20 }}
//                           animate={{ opacity: 1, y: 0 }}
//                           transition={{ delay: i * 0.05 }}
//                           className="group/vol bg-gray-800 p-6 hover:bg-black transition-colors aspect-[3/4] flex flex-col justify-between"
//                         >
//                           <div className="text-4xl font-black text-white/20 group-hover/vol:text-white/40 transition-colors">
//                             {String(i + 1).padStart(2, '0')}
//                           </div>
//                           <div>
//                             <div className="text-white font-bold mb-3">{vol.name}</div>
//                             <div className="flex items-center gap-2 text-white text-sm">
//                               <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
//                               </svg>
//                               <span className="font-bold">PDF</span>
//                             </div>
//                           </div>
//                         </motion.a>
//                       ))}
//                     </div>
//                   </motion.div>
//                 )}
//               </AnimatePresence>
//             </motion.div>
//           ))}
//         </div>
//       </section>

//       {/* Other Resources - Dynamic Grid with Filter */}
//       <section id="resources" className="py-32 px-8 md:px-20 lg:px-32 bg-gray-50">
//         <motion.div
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           className="mb-20"
//         >
//           <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-12">
//             <div>
//               <h2 className="text-7xl md:text-8xl font-black text-black leading-none mb-6">
//                 ISLAMIC
//                 <br />
//                 RESOURCES
//               </h2>
//               <div className="w-24 h-1 bg-gray-800"></div>
//             </div>
            
//             <div className="flex gap-3">
//               <button
//                 onClick={() => setViewMode('grid')}
//                 className={`w-12 h-12 flex items-center justify-center ${viewMode === 'grid' ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'} transition-colors`}
//               >
//                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
//                 </svg>
//               </button>
//               <button
//                 onClick={() => setViewMode('list')}
//                 className={`w-12 h-12 flex items-center justify-center ${viewMode === 'list' ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'} transition-colors`}
//               >
//                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
//                 </svg>
//               </button>
//             </div>
//           </div>
//         </motion.div>

//         {/* Category Pills */}
//         <div className="flex flex-wrap gap-3 mb-16">
//           {Object.keys(otherGrouped).map((category) => (
//             <button
//               key={category}
//               onClick={() => setSelectedCategory(category)}
//               className={`px-8 py-4 text-sm font-black tracking-wider transition-all ${
//                 selectedCategory === category
//                   ? 'bg-gray-800 text-white'
//                   : 'bg-white text-gray-800 hover:bg-gray-200'
//               }`}
//             >
//               {categoryConfig[category].label.toUpperCase()}
//             </button>
//           ))}
//         </div>

//         {/* Content */}
//         <AnimatePresence mode="wait">
//           <motion.div
//             key={selectedCategory + viewMode}
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             exit={{ opacity: 0, y: -20 }}
//             transition={{ duration: 0.3 }}
//           >
//             {viewMode === 'grid' ? (
//               <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
//                 {otherGrouped[selectedCategory].map((pdf, index) => (
//                   <motion.div
//                     key={index}
//                     initial={{ opacity: 0, scale: 0.9 }}
//                     animate={{ opacity: 1, scale: 1 }}
//                     transition={{ delay: index * 0.05 }}
//                     className="group bg-white hover:shadow-2xl transition-all duration-300"
//                   >
//                     <div className="aspect-[3/4] bg-gray-800 relative overflow-hidden">
//                       <div className="absolute inset-0 flex items-center justify-center">
//                         <svg className="w-24 h-24 text-white/10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
//                         </svg>
//                       </div>
//                       <div className="absolute top-4 right-4 bg-white text-gray-800 px-3 py-1 text-xs font-black">
//                         {pdf.language}
//                       </div>
//                       <a
//                         href={pdf.link}
//                         download
//                         className="absolute inset-0 bg-black/0 hover:bg-black/80 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100"
//                       >
//                         <div className="text-white text-center">
//                           <svg className="w-12 h-12 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
//                           </svg>
//                           <div className="font-black">DOWNLOAD</div>
//                         </div>
//                       </a>
//                     </div>
//                     <div className="p-6">
//                       <h4 className="text-lg font-bold text-black mb-2 line-clamp-2">
//                         {pdf.subtitle}
//                       </h4>
//                       <p className="text-sm text-gray-600 font-semibold">PDF Document</p>
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>
//             ) : (
//               <div className="space-y-2">
//                 {otherGrouped[selectedCategory].map((pdf, index) => (
//                   <motion.div
//                     key={index}
//                     initial={{ opacity: 0, x: -20 }}
//                     animate={{ opacity: 1, x: 0 }}
//                     transition={{ delay: index * 0.05 }}
//                     className="group bg-white hover:bg-gray-100 transition-colors"
//                   >
//                     <div className="flex items-center gap-6 p-6">
//                       <div className="text-3xl font-black text-gray-300 group-hover:text-gray-800 transition-colors w-16">
//                         {String(index + 1).padStart(2, '0')}
//                       </div>
//                       <div className="w-16 h-20 bg-gray-800 flex-shrink-0 flex items-center justify-center">
//                         <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
//                         </svg>
//                       </div>
//                       <div className="flex-1 min-w-0">
//                         <h4 className="text-xl font-bold text-black mb-1 truncate">
//                           {pdf.subtitle}
//                         </h4>
//                         <p className="text-sm text-gray-600 font-semibold">{pdf.language} Translation</p>
//                       </div>
//                       <a
//                         href={pdf.link}
//                         download
//                         className="flex-shrink-0 bg-gray-800 text-white px-8 py-4 font-black text-sm hover:bg-black transition-colors"
//                       >
//                         DOWNLOAD
//                       </a>
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>
//             )}
//           </motion.div>
//         </AnimatePresence>
//       </section>

    
//     </div>
//   );
// };

// export default PdfLibrary;



// import React, { useState } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';

// const hadeesCollections = [
//   {
//     subtitle: "ABU_DAWOOD",
//     displayName: "Sunan Abu Dawood",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/ABU_DAWOOD/AB_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/ABU_DAWOOD/AB_02.pdf" },
//       { name: "Volume 3", file: "images/Hadees/ABU_DAWOOD/AB_03.pdf" },
//       { name: "Volume 4", file: "images/Hadees/ABU_DAWOOD/AB_04.pdf" },
//     ],
//   },
//   {
//     subtitle: "IBN_MAJAH",
//     displayName: "Sunan Ibn Majah",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/IBN_MAJAH/IM_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/IBN_MAJAH/IM_02.pdf" },
//       { name: "Volume 3", file: "images/Hadees/IBN_MAJAH/IM_03.pdf" },
//       { name: "Volume 4", file: "images/Hadees/IBN_MAJAH/IM_04.pdf" },
//       { name: "Volume 5", file: "images/Hadees/IBN_MAJAH/IM_05.pdf" },
//     ],
//   },
//   {
//     subtitle: "JAMI_AT_TIRMIDHI",
//     displayName: "Jami' at-Tirmidhi",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/JAMI_AT_TIRMIDHI/JT_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/JAMI_AT_TIRMIDHI/JT_02.pdf" },
//     ],
//   },
//   {
//     subtitle: "SAHIH_BUKHARI",
//     displayName: "Sahih al-Bukhari",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/SAHIH_BUKHARI/SB_001.pdf" },
//       { name: "Volume 2", file: "images/Hadees/SAHIH_BUKHARI/SB_002.pdf" },
//       { name: "Volume 3", file: "images/Hadees/SAHIH_BUKHARI/SB_003.pdf" },
//       { name: "Volume 4", file: "images/Hadees/SAHIH_BUKHARI/SB_004.pdf" },
//       { name: "Volume 5", file: "images/Hadees/SAHIH_BUKHARI/SB_005.pdf" },
//       { name: "Volume 6", file: "images/Hadees/SAHIH_BUKHARI/SB_006.pdf" },
//     ],
//   },
//   {
//     subtitle: "SAHIH_MUSLIM",
//     displayName: "Sahih Muslim",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/SAHIH_MUSLIM/SM_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/SAHIH_MUSLIM/SM_02.pdf" },
//       { name: "Volume 3", file: "images/Hadees/SAHIH_MUSLIM/SM_03.pdf" },
//       { name: "Volume 4", file: "images/Hadees/SAHIH_MUSLIM/SM_04.pdf" },
//       { name: "Volume 5", file: "images/Hadees/SAHIH_MUSLIM/SM_05.pdf" },
//     ],
//   },
//   {
//     subtitle: "SUNAN_NASAI",
//     displayName: "Sunan an-Nasa'i",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/SUNAN_NASAI/NS_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/SUNAN_NASAI/NS_02.pdf" },
//       { name: "Volume 3", file: "images/Hadees/SUNAN_NASAI/NS_03.pdf" },
//       { name: "Volume 4", file: "images/Hadees/SUNAN_NASAI/NS_04.pdf" },
//       { name: "Volume 5", file: "images/Hadees/SUNAN_NASAI/NS_05.pdf" },
//       { name: "Volume 6", file: "images/Hadees/SUNAN_NASAI/NS_06.pdf" },
//       { name: "Volume 7", file: "images/Hadees/SUNAN_NASAI/NS_07.pdf" },
//     ],
//   },
// ];

// const otherPdfs = [
//   { title: "Qur'an", subtitle: "Quran – Urdu Translation", link: "images/quran/Urdu.pdf", language: "Urdu" },
//   { title: "Qur'an", subtitle: "Quran – Telugu Translation", link: "images/quran/Telugu.pdf", language: "Telugu" },
//   { title: "Qur'an", subtitle: "Quran – English Translation", link: "images/quran/English.pdf", language: "English" },
//   { title: "Aqeeda", subtitle: "Aqeedah Tawheed - Sh. Fawzan", link: "images/Aqeeda/aqeedah-tawheed-shakhfawzan-teluguislam.net-mobile-friendly.pdf", language: "Telugu" },
//   { title: "Aqeeda", subtitle: "Four Principles of Shirk", link: "images/Aqeeda/four-principles-of-shirk-mobile-friendly.pdf", language: "Telugu" },
//   { title: "Aqeeda", subtitle: "Taqwiyatul Iman", link: "images/Aqeeda/taqwiyatul-iman.pdf", language: "Telugu" },
//   { title: "Aqeeda", subtitle: "Usool al-Thalatha", link: "images/Aqeeda/usool-al-thalatha-zulfi.pdf", language: "Telugu" },
//   { title: "Aqeeda", subtitle: "Explanation of the Three Principles", link: "images/Aqeeda/Explanation of the Three Principles.pdf", language: "Urdu" },
//   { title: "Seerat", subtitle: "Ar-Raheeq Al-Makhtum", link: "/images/Seerat/ar-raheeq-al-makhtoum-small-size.pdf", language: "Telugu" },
//   { title: "Seerat", subtitle: "Ar-Raheeq Al-Makhtum", link: "/images/Seerat/Ar-raheeqAl-makhtumurdu.pdf", language: "Urdu" },
//   { title: "Seerat", subtitle: "Mukhtasar Seerat", link: "/images/Seerat/Mukhtasar-Seerat.pdf", language: "Urdu" },
//   { title: "Seerat", subtitle: "The Sealed Nectar", link: "/images/Seerat/sealed_nectar.pdf", language: "English" },
//   { title: "Sunnah", subtitle: "Bidah - Sh. Fawzan", link: "/images/Sunnah/bida-sh.fawzan-book.pdf", language: "Telugu" },
//   { title: "Sunnah", subtitle: "Following the Prophet's Sunnah", link: "/images/Sunnah/pravaktha-sunnath-anusarana-m.d-iqbal-kailani.pdf", language: "Telugu" },
//   { title: "Sunnah", subtitle: "Obedience to the Prophet", link: "/images/Sunnah/pravaktha-vidheyatha-mobile.pdf", language: "Telugu" },
//   { title: "Important Lessons", subtitle: "Important Lessons for Every Muslim", link: "images/Important lesson/urduimportantleassons.pdf", language: "Urdu" },
//   { title: "Important Lessons", subtitle: "Important Lessons for Every Muslim", link: "images/Important lesson/telugu-importantleassons.pdf", language: "Telugu" },
// ];

// const categoryConfig = {
//   "Qur'an": { 
//     label: "Holy Qur'an",
//     description: "Divine revelation in multiple languages"
//   },
//   "Aqeeda": { 
//     label: "Aqeeda (Belief)",
//     description: "Foundations of Islamic faith and creed"
//   },
//   "Seerat": { 
//     label: "Seerat (Life of Prophet ﷺ)",
//     description: "Biography of Prophet Muhammad ﷺ"
//   },
//   "Sunnah": { 
//     label: "Sunnah",
//     description: "Teachings and traditions of the Prophet ﷺ"
//   },
//   "Important Lessons": { 
//     label: "Important Lessons",
//     description: "Essential knowledge for every Muslim"
//   },
// };

// const PdfLibrary = () => {
//   const [expandedHadees, setExpandedHadees] = useState(null);

//   const handleToggle = (index) => {
//     setExpandedHadees(expandedHadees === index ? null : index);
//   };

//   const otherGrouped = otherPdfs.reduce((acc, curr) => {
//     acc[curr.title] = acc[curr.title] || [];
//     acc[curr.title].push(curr);
//     return acc;
//   }, {});

//   return (
//     <div className="min-h-screen bg-white">
//       {/* Hero Section - Image with Text Overlay */}
//       <section className="relative h-screen flex items-center justify-center overflow-hidden">
//         {/* Background Image */}
//         <div className="absolute inset-0">
//           <img 
//             src="https://images.unsplash.com/photo-1609599006353-e629aaabfeae?q=80&w=2831"
//             alt="Islamic Library"
//             className="w-full h-full object-cover"
//           />
//           {/* Dark Overlay */}
//           <div className="absolute inset-0 bg-black/60"></div>
//         </div>

//         {/* Content Overlay */}
//         <div className="relative z-10 text-center px-6 max-w-6xl mx-auto">
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8 }}
//           >
//             {/* Main Title */}
//             <h1 className="text-6xl md:text-8xl lg:text-9xl font-black text-white mb-6 tracking-tight">
//               Islamic Library
//             </h1>
            
//             {/* Subtitle */}
//             <p className="text-2xl md:text-3xl text-white/90 mb-8 font-light">
//               Access authentic Islamic knowledge and resources
//             </p>

//             {/* Divider */}
//             <div className="flex items-center justify-center gap-4 mb-8">
//               <div className="w-24 h-px bg-white/40"></div>
//               <div className="w-2 h-2 bg-white rounded-full"></div>
//               <div className="w-24 h-px bg-white/40"></div>
//             </div>

//             {/* Arabic Text */}
//             <div className="text-3xl md:text-5xl text-white mb-4 font-arabic">
//               إِنَّ هَٰذَا ٱلْقُرْءَانَ يَهْدِى لِلَّتِى هِىَ أَقْوَمُ
//             </div>
//             <p className="text-lg md:text-xl text-white/80 italic">
//               "Indeed, this Qur'an guides to that which is most just and right."
//             </p>
//             <p className="text-sm text-white/60 mt-2 tracking-widest">SURAH AL-ISRA (17:9)</p>
//           </motion.div>

//           {/* Scroll Indicator */}
//           <motion.div
//             className="absolute bottom-10 left-1/2 transform -translate-x-1/2"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ delay: 1 }}
//           >
//             <motion.div
//               animate={{ y: [0, 10, 0] }}
//               transition={{ duration: 1.5, repeat: Infinity }}
//               className="text-white"
//             >
//               <svg className="w-8 h-8 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
//               </svg>
//             </motion.div>
//           </motion.div>
//         </div>
//       </section>

//       {/* Hadees Collections Section */}
//       <section className="py-24 px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           {/* Section Header */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//             viewport={{ once: true }}
//             className="text-center mb-16"
//           >
//             <div className="inline-block px-6 py-2 bg-gray-800 text-white text-sm font-bold tracking-widest mb-6 rounded-full">
//               AUTHENTIC COLLECTIONS
//             </div>
//             <h2 className="text-5xl md:text-6xl font-black text-black mb-4">
//               Hadees Collections
//             </h2>
//             <p className="text-xl text-gray-600 max-w-2xl mx-auto">
//               The six authentic books of Hadith (Kutub al-Sittah)
//             </p>
//           </motion.div>

//           {/* Collections Grid */}
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {hadeesCollections.map((collection, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.5, delay: index * 0.1 }}
//                 viewport={{ once: true }}
//               >
//                 <div className="border-2 border-gray-200 rounded-2xl overflow-hidden hover:border-gray-800 transition-all duration-300 hover:shadow-xl">
//                   {/* Header */}
//                   <div 
//                     className="p-6 bg-white cursor-pointer hover:bg-gray-50 transition-colors duration-300"
//                     onClick={() => handleToggle(index)}
//                   >
//                     <div className="flex items-start justify-between mb-4">
//                       <div className="flex-1">
//                         <h3 className="text-2xl font-bold text-black mb-2">
//                           {collection.displayName}
//                         </h3>
//                         <div className="inline-flex items-center gap-2 text-sm text-gray-600 bg-gray-100 px-4 py-2 rounded-full">
//                           <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
//                           </svg>
//                           <span className="font-semibold">{collection.volumes.length} Volumes</span>
//                         </div>
//                       </div>
//                       <div className={`w-10 h-10 flex items-center justify-center rounded-full bg-gray-800 text-white transition-transform duration-300 ${expandedHadees === index ? 'rotate-180' : ''}`}>
//                         <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
//                         </svg>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Volumes List */}
//                   <AnimatePresence>
//                     {expandedHadees === index && (
//                       <motion.div
//                         initial={{ height: 0 }}
//                         animate={{ height: "auto" }}
//                         exit={{ height: 0 }}
//                         transition={{ duration: 0.3 }}
//                         className="overflow-hidden border-t-2 border-gray-200"
//                       >
//                         <div className="p-4 space-y-2 bg-gray-50">
//                           {collection.volumes.map((vol, i) => (
//                             <motion.div
//                               key={i}
//                               initial={{ opacity: 0, x: -20 }}
//                               animate={{ opacity: 1, x: 0 }}
//                               transition={{ delay: i * 0.05 }}
//                             >
//                               <div className="flex items-center justify-between p-4 bg-white rounded-xl border border-gray-200 hover:border-gray-800 transition-all duration-300">
//                                 <div className="flex items-center gap-3">
//                                   <div className="w-10 h-10 bg-gray-800 text-white rounded-lg flex items-center justify-center font-bold">
//                                     {i + 1}
//                                   </div>
//                                   <span className="font-semibold text-black">{vol.name}</span>
//                                 </div>
//                                 <a
//                                   href={vol.file}
//                                   download
//                                   className="flex items-center gap-2 bg-gray-800 text-white px-4 py-2 rounded-lg font-semibold hover:bg-black transition-colors duration-300"
//                                 >
//                                   <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
//                                   </svg>
//                                   <span className="hidden sm:inline">Download</span>
//                                 </a>
//                               </div>
//                             </motion.div>
//                           ))}
//                         </div>
//                       </motion.div>
//                     )}
//                   </AnimatePresence>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Other Collections Section */}
//       <section className="py-24 px-6 bg-gray-50">
//         <div className="max-w-7xl mx-auto space-y-24">
//           {Object.keys(otherGrouped).map((category, categoryIndex) => {
//             const config = categoryConfig[category];
//             return (
//               <div key={categoryIndex}>
//                 {/* Category Header */}
//                 <motion.div
//                   initial={{ opacity: 0, y: 20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.6 }}
//                   viewport={{ once: true }}
//                   className="mb-12"
//                 >
//                   <h2 className="text-4xl md:text-5xl font-black text-black mb-3">
//                     {config.label}
//                   </h2>
//                   <p className="text-lg text-gray-600">
//                     {config.description}
//                   </p>
//                   <div className="mt-4 h-1 w-24 bg-gray-800 rounded-full"></div>
//                 </motion.div>

//                 {/* PDF Cards Grid */}
//                 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
//                   {otherGrouped[category].map((pdf, pdfIndex) => (
//                     <motion.div
//                       key={pdfIndex}
//                       initial={{ opacity: 0, y: 20 }}
//                       whileInView={{ opacity: 1, y: 0 }}
//                       transition={{ duration: 0.5, delay: pdfIndex * 0.05 }}
//                       viewport={{ once: true }}
//                     >
//                       <div className="group bg-white border-2 border-gray-200 rounded-2xl overflow-hidden hover:border-gray-800 hover:shadow-xl transition-all duration-300">
//                         {/* PDF Icon Section */}
//                         <div className="relative p-8 bg-white border-b-2 border-gray-200 group-hover:border-gray-800 transition-colors duration-300">
//                           {/* Language Badge */}
//                           <div className="absolute top-4 right-4">
//                             <span className="bg-gray-800 text-white text-xs font-bold px-3 py-1 rounded-full">
//                               {pdf.language}
//                             </span>
//                           </div>
                          
//                           {/* PDF Icon */}
//                           <div className="flex justify-center mb-4">
//                             <div className="w-24 h-32 bg-gray-800 rounded-lg shadow-lg flex items-center justify-center group-hover:scale-105 transition-transform duration-300">
//                               <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//                               </svg>
//                             </div>
//                           </div>
//                         </div>

//                         {/* Content Section */}
//                         <div className="p-6">
//                           <h3 className="text-base font-bold text-black mb-4 line-clamp-2 min-h-[3rem]">
//                             {pdf.subtitle}
//                           </h3>

//                           {/* Download Button */}
//                           <a
//                             href={pdf.link}
//                             download
//                             className="w-full flex items-center justify-center gap-2 bg-gray-800 text-white px-6 py-3 rounded-xl font-semibold hover:bg-black transition-colors duration-300"
//                           >
//                             <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
//                             </svg>
//                             <span>Download PDF</span>
//                           </a>
//                         </div>
//                       </div>
//                     </motion.div>
//                   ))}
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </section>

    
//     </div>
//   );
// };

// export default PdfLibrary;


// import React, { useState } from 'react';


// const hadeesCollections = [
//   {
//     subtitle: "ABU_DAWOOD ",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/ABU_DAWOOD/AB_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/ABU_DAWOOD/AB_02.pdf" },
//       { name: "Volume 3", file: "images/Hadees/ABU_DAWOOD/AB_03.pdf" },
//       { name: "Volume 4", file: "images/Hadees/ABU_DAWOOD/AB_04.pdf" },
//     ],
//   },
//   {
//     subtitle: "IBN_MAJAH ",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/IBN_MAJAH/IM_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/IBN_MAJAH/IM_02.pdf" },
//       { name: "Volume 3", file: "images/Hadees/IBN_MAJAH/IM_03.pdf" },
//       { name: "Volume 4", file: "images/Hadees/IBN_MAJAH/IM_04.pdf" },
//       { name: "Volume 5", file: "images/Hadees/IBN_MAJAH/IM_05.pdf" },
//     ],
//   },

//    {
//     subtitle: "JAMI_AT_TIRMIDHI ",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/JAMI_AT_TIRMIDHI/JT_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/JAMI_AT_TIRMIDHI/JT_01.pdf" },
//     ],
//   },

//  {
//     subtitle: "SAHIH_BUKHARI ",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/SAHIH_BUKHARI/SB_001.pdf" },
//       { name: "Volume 2", file: "images/Hadees/SAHIH_BUKHARI/SB_002.pdf" },
//       { name: "Volume 3", file: "images/Hadees/SAHIH_BUKHARI/SB_003.pdf" },
//       { name: "Volume 4", file: "images/Hadees/SAHIH_BUKHARI/SB_004.pdf" },
//       { name: "Volume 5", file: "images/Hadees/SAHIH_BUKHARI/SB_005.pdf" },
//       { name: "Volume 6", file: "images/Hadees/SAHIH_BUKHARI/SB_006.pdf" },

//     ],
//   },

//    {
//     subtitle: "SAHIH_MUSLIM ",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/SAHIH_MUSLIM/SM_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/SAHIH_MUSLIM/SM_02.pdf" },
//       { name: "Volume 3", file: "images/Hadees/SAHIH_MUSLIM/SM_03.pdf" },
//       { name: "Volume 4", file: "images/Hadees/SAHIH_MUSLIM/SM_04.pdf" },
//       { name: "Volume 5", file: "images/Hadees/SAHIH_MUSLIM/SM_05.pdf" },

//     ],
//   },

//    {
//     subtitle: "SUNAN_NASAI ",
//     volumes: [
//       { name: "Volume 1", file: "images/Hadees/SUNAN_NASAI/NS_01.pdf" },
//       { name: "Volume 2", file: "images/Hadees/SUNAN_NASAI/NS_02.pdf" },
//       { name: "Volume 3", file: "images/Hadees/SUNAN_NASAI/NS_03.pdf" },
//       { name: "Volume 4", file: "images/Hadees/SUNAN_NASAI/NS_04.pdf" },
//       { name: "Volume 5", file: "images/Hadees/SUNAN_NASAI/NS_05.pdf" },
//       { name: "Volume 6", file: "images/Hadees/SUNAN_NASAI/NS_06.pdf" },
//       { name: "Volume 7", file: "images/Hadees/SUNAN_NASAI/NS_07.pdf" },

//     ],
//   },
// ];


// const otherPdfs = [
//   { title: "Qur’an", subtitle: "Quran – Urdu Translation", link: "images/quran/Urdu.pdf" },
//   { title: "Qur’an", subtitle: "Quran – Telugu Translation", link: "images/quran/Telugu.pdf" },
//   { title: "Qur’an", subtitle: "Quran – English Translation", link: "images/quran/English.pdf" },
//   { title: "Aqeeda", subtitle: "aqeedah-tawheed-shakhfawzan (Telugu)", link: "images/Aqeeda/aqeedah-tawheed-shakhfawzan-teluguislam.net-mobile-friendly.pdf" },
//   { title: "Aqeeda", subtitle: "four-principles-of-shirk (Telugu)", link: "images/Aqeeda/four-principles-of-shirk-mobile-friendly.pdf" },
//   { title: "Aqeeda", subtitle: "taqwiyatul-iman (Telugu)", link: "images/Aqeeda/taqwiyatul-iman.pdf" },
//   { title: "Aqeeda", subtitle: "usool-al-thalatha-zulfi (Telugu)", link: "images/Aqeeda/usool-al-thalatha-zulfi.pdf" },
//   { title: "Aqeeda", subtitle: "Explanation of the Three Principles (Urdu)", link: "images/Aqeeda/Explanation of the Three Principles.pdf" },
//   { title: "Seerat (Life of Prophet ﷺ)", subtitle: "Ar-raheeq-al-makhtoum (Telugu)", link: "/images/Seerat/ar-raheeq-al-makhtoum-small-size.pdf" },
//   { title: "Seerat (Life of Prophet ﷺ)", subtitle: "Ar-raheeq-al-makhtoum (Urdu)", link: "/images/Seerat/Ar-raheeqAl-makhtumurdu.pdf" },
//   { title: "Seerat (Life of Prophet ﷺ)", subtitle: "Mukhtasar-Seerat (Urdu)", link: "/images/Seerat/Mukhtasar-Seerat.pdf" },
//   { title: "Seerat (Life of Prophet ﷺ)", subtitle: "Sealed_nectar (Urdu)", link: "/images/Seerat/sealed_nectar.pdf" },
//   { title: "Sunnah", subtitle: "bidat-sh.fawzan-book (Telugu)", link: "/images/Sunnah/bida-sh.fawzan-book.pdf" },
//   { title: "Sunnah", subtitle: "pravaktha-sunnath-anusarana-m.d-iqbal-kailani (Telugu)", link: "/images/Sunnah/pravaktha-sunnath-anusarana-m.d-iqbal-kailani.pdf" },
//   { title: "Sunnah", subtitle: "pravaktha-vidheyatha (Telugu)", link: "/images/Sunnah/pravaktha-vidheyatha-mobile.pdf" },
//   { title: "Important lesson", subtitle: "Urdu", link: "images/Important lesson/urduimportantleassons.pdf" },
//   { title: "Important lesson", subtitle: "Telugu", link: "images/Important lesson/telugu-importantleassons.pdf" },
// ];

// const categoryLabels = {
//   "Qur’an": "📖 Qur’an Collection",
//   "Aqeeda": "🧠 Aqeeda Collection",
//   "Seerat (Life of Prophet ﷺ)": "🕋 Seerat (Life of Prophet ﷺ)",
//   "Sunnah": "🌟 Sunnah Collection",
//   "Important lesson": "📌 Important Lessons",
// };

// const PdfLibrary = () => {
//   const [openIndex, setOpenIndex] = useState(null);

//   const handleToggle = (index) => {
//     setOpenIndex(openIndex === index ? null : index);
//   };

//   const otherGrouped = otherPdfs.reduce((acc, curr) => {
//     acc[curr.title] = acc[curr.title] || [];
//     acc[curr.title].push(curr);
//     return acc;
//   }, {});

//   return (
//     <div className="font-serif bg-[#fdfaf6] text-[#1f2d27] pb-[450px] md:pb-80">
//       {/* Header */}
//       <section className="bg-[#1e3d32] py-16 text-center text-white relative">
//         <div className="max-w-4xl mx-auto px-6">
//           <div className="text-orange-400 pt-32 text-3xl mb-4">﴾ ﴿</div>
//           <h1 className="text-4xl font-bold mb-4">إِنَّ هَـٰذَا ٱلْقُرْآنَ يَهْدِي لِلَّتِي هِيَ أَقْوَمُ</h1>
//           <p className="text-lg italic mb-2">"Indeed, this Qur’an guides to that which is most just and right."</p>
//           <p className="text-sm">(Surah Al-Isra (17:9))</p>
//         </div>
//       </section>

//       {/* Hadees Section */}
//       <section className="max-w-6xl mx-auto py-16 px-6">
//   <h2 className="text-3xl font-semibold mb-10">📘 Hadees Collections</h2>
//   <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//     {hadeesCollections.map((collection, index) => (
//       <div key={index} className="bg-white border border-gray-200 rounded-xl shadow-md p-6">
//         <h3
//           onClick={() => handleToggle(index)}
//           className="text-lg font-semibold mb-2 cursor-pointer text-center hover:text-[#285943] transition"
//         >
//           {collection.subtitle}
//         </h3>

//         {openIndex === index && (
//           <div className="flex flex-col gap-3 mt-4">
//             {collection.volumes.map((vol, i) => (
//               <div key={i} className="flex justify-between  items-center">
//                 <span className="text-sm">{vol.name}</span>
//                 <div className="flex gap-2">
//                   <a
//                     href={vol.file}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="bg-[#285943] text-white px-3 py-1 rounded hover:bg-[#1e3d32] text-sm"
//                   >
//                     View
//                   </a>
//                   <a
//                     href={vol.file}
//                     download
//                     className="bg-[#d4af37] text-white px-3 py-1 rounded hover:bg-[#bfa327] text-sm"
//                   >
//                     Download
//                   </a>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     ))}
//   </div>
// </section>


//       {/* Other Collections */}
//       <section className="max-w-6xl mx-auto py-10 px-6">
//         {Object.keys(otherGrouped).map((category, index) => (
//           <div key={index} className="mb-12">
//             <h2 className="text-2xl font-bold mb-6">{categoryLabels[category] || category}</h2>
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
//               {otherGrouped[category].map((pdf, i) => (
//                 <div
//                   key={i}
//                   className="bg-white border border-gray-200 rounded-xl shadow-md p-6 flex flex-col justify-between transition-all hover:shadow-xl"
//                 >
//                   <div>
//                     <p className="text-sm text-gray-600 font-medium mb-2">{pdf.subtitle}</p>
//                   </div>
//                   <div className="mt-4 flex gap-4">
//                     <a
//                       href={pdf.link}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex-1 text-center bg-[#285943] text-white py-2 rounded-lg hover:bg-[#1e3d32] transition"
//                     >
//                       View
//                     </a>
//                     <a
//                       href={pdf.link}
//                       download
//                       className="flex-1 text-center bg-[#d4af37] text-white py-2 rounded-lg hover:bg-[#bfa327] transition"
//                     >
//                       Download
//                     </a>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         ))}
//       </section>
//     </div>
//   );
// };

// export default PdfLibrary;



